import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfcsc } from "./zfc_shopping_cart";
export class zfcsn {
    static init(sideNavData, socialData, envelopeData) {
        try {
            var sideNavTemplate = zfUtils.handlebarsCompile(`
				<div class="zfc-sideNav sideNavContainer">
					<ul class="sideNavContainerList not-default" role="menu">
					{{#each items}}
						<li class="zfcsn-sidenav-item {{class}}" {{#ifCond modal '==' 'true'}}data-modal-uuid="{{class}}-modal"{{/ifCond}} role="none">
							<a class="zfcui-prometo-medium" role="menuitem" href="{{href}}" aria-label="{{#trans trans}}{{/trans}}">
								<span class="zfcui-icon {{#ifCond class '!includes' 'zfc-sidenav-custom'}} {{icon}} {{/ifCond}}" role="button" aria-hidden="true">
									{{#ifCond class 'includes' 'zfc-sidenav-custom'}}
										{{#ifCond icon '!=' ''}}
											<img class='zfcsn-sidenav-custom-icon' src="{{icon}}">
										{{/ifCond}}
										{{#ifCond svg '!=' ''}}
											<svg class="zfcsn-sidenav-custom-svg" style="width: 36px;height: 36px" viewBox="0 0 100 100" preserveAspectRatio="none">
											  <defs>
												<mask id="zfc-sidenav-svg-{{@index}}" x="0" y="0" width="100" height="100">
												  <image xlink:href="{{svg}}" x="0" y="0" width="100" height="100" src="{{svg}}"></image>
												</mask>
											  </defs>
											  <rect x="0" y="0" width="100" height="100" style="fill: currentColor" mask="url(#zfc-sidenav-svg-{{@index}})"></rect>
											</svg>
										{{/ifCond}}
									{{/ifCond}}
									{{#ifCond class '==' 'zfc-sidenav-cart'}}<span class='zfcsn-cart-counter'></span>{{/ifCond}}</span>
                				<span>{{#trans trans}}{{/trans}}</span>
            				</a>
        				</li>
					{{/each}}
						<li class="zfcsn-sidenav-item zfc-sidenav-dots" role="none"><a role="menuitem"><span class="zfcui-icon">...</span></a></li>
			        	<li class="zfcsn-sidenav-item zfc-sidenav-close" role="none"><a role="menuitem"><span class="zfcui-icon zfcui-icon-cross"></span></a></li>
					</ul>
					<div class="zfc-sideNav-data"></div>
				</div>`);
            $(".body-wrapper").append(zfUtils.handlebarsProcessTemplate(sideNavTemplate, sideNavData));
            var socialTemplate = zfUtils.handlebarsCompile(`
				<div class="zfcacc-item">
					<div data-key="zfc-sidenav-share-modal"></div>
					<div class="zfcacc-accordion-section-content">
						<div class="zfcui-modal-title">
							<h3>{{#trans 'share_this_page_on'}}{{/trans}}</h3>
							` +
                zfc.dividerHtml +
                `
						</div>       
						<div class="zfcshare-overlay-content">
							<div class="zfcshare-share-container">
							{{#each items}}
								<a title="{{#trans trans}}{{/trans}}" class="zfcshare-link-share zfcshare-circle {{icon-class}} zfcui-color-white" href="{{href}}{{#canonical}}{{/canonical}}" target="_blank" aria-label="opens in a new tab">
									<span class="zfc-hide-accessibly">{{#trans trans}}{{/trans}}</span>
									<span class="zfcshare-icon zfcui-icon {{class}}"></span>
								</a>
							{{/each}}
							</div>
						</div>
					</div>
				</div>`);
            if (socialData.items.length)
                $(".zfc-sideNav-data").append(zfUtils.handlebarsProcessTemplate(socialTemplate, socialData));
            var envelopeTemplate = zfUtils.handlebarsCompile(`
				<div class="zfcacc-item">
					<div data-key="zfc-sidenav-contact-modal"></div>
					<div class="zfcacc-accordion-section-content">
						{{#if items.length}}
							<div class="zfcui-modal-title">
								<h3>{{#trans 'get_in_touch'}}{{/trans}}</h3>
								` +
                zfc.dividerHtml +
                `
							</div> 
							<ul class="zfch-contact-git-list not-default">
								{{#each items}}
									<li><a class="zfch-contact-link zfcui-color-cyan zfcui-prometo-medium" href="{{href}}" target="{{target}}">
										{{text}}
									</a></li>
								{{/each}}
							</ul>
						{{/if}}
						{{#ifCond address '!=' ''}}
							<div class="zfcui-modal-title">
								<h3>{{#trans 'address'}}{{/trans}}</h3>
								` +
                zfc.dividerHtml +
                `
							</div>
							<div class="zfch-overlay-content zfch-contact-address-content">
								{{#decodeHtml address}}{{/decodeHtml}}
							</div>
						{{/ifCond}}
					</div>
				</div>`);
            $(".zfcsn-sidenav-item").hover(function () {
                if ($(this).find(".zfcui-icon").next().width() + 30 + 16 + 20 > 230)
                    $(this)
                        .addClass("zfcsn-sidenav-item-adjusted")
                        .css("right", $(this).find(".zfcui-icon").next().width() + 20);
            }, function () {
                if ($(this).hasClass("zfcsn-sidenav-item-adjusted"))
                    $(this).removeClass("zfcsn-sidenav-item-adjusted").css("right", 0);
            });
            if (envelopeData.items.length || envelopeData.address != "")
                $(".body-wrapper").append(zfUtils.handlebarsProcessTemplate(envelopeTemplate, envelopeData));
            var isMobileSidenav = (window.innerWidth || 0) <= 959;
            if (isMobileSidenav) {
                $(".zfc-sidenav-locations").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-contact").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-cart").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-custom").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-share").addClass("zfcsn-collapsed");
            }
            else {
                $(".zfc-sidenav-locations").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-contact").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-cart").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-custom").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-share").removeClass("zfcsn-collapsed");
            }
            if ($(".zfc-sidenav-cart").length == 0)
                $(".zfcpc-cart-button").hide();
            zfcsc.init();
            zfcsc.reinit();
            $(".zfc-sidenav-close")
                .off("click.zfcsn")
                .on("click.zfcsn", function () {
                if (!isMobileSidenav)
                    return;
                $(".zfc-sidenav-locations").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-contact").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-cart").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-share").addClass("zfcsn-collapsed");
                $(".zfc-sidenav-custom").addClass("zfcsn-collapsed");
                $(".zfc-sideNav").removeClass("active");
            });
            $(".zfc-sidenav-dots")
                .off("click.zfcsn")
                .on("click.zfcsn", function () {
                if (!isMobileSidenav)
                    return;
                $(".zfc-sideNav").addClass("active");
                $(".zfc-sidenav-custom").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-share").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-cart").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-contact").removeClass("zfcsn-collapsed");
                $(".zfc-sidenav-locations").removeClass("zfcsn-collapsed");
            });
            $(".zfc-sideNav").find("[data-modal-uuid]").each(zfc.modalize);
            $(".zfc-sideNav").show();
        }
        catch (err) {
            console.log("Initalization failed: zfcsn.init() " + err.message);
        }
    }
}
